import { LOCATION_CHANGE } from 'connected-react-router';
import produce from 'immer';
import { matchPath } from 'react-router-dom';
import { Reducer } from 'redux';
import { LOGOUT_API_SUCCESS } from '../../../global/logout/constants';
import { RESET_SESSION } from '../../../global/session/constants';
import { COLLECTIONS_URL } from '../../../global/urls';
import { makeQueryKey } from '../../../helpers/utils';
import { LOGIN_API_SUCCESS } from '../../Login/constants';
import { SELECT_SHOP_API_SUCCESS } from '../../ShopSelector/constants';
import { CollectionsActionTypes } from '../actionTypes';
import {
  COLLECTIONS_FETCH_API_FAILURE,
  COLLECTIONS_FETCH_API_REQUEST,
  COLLECTIONS_FETCH_API_SUCCESS,
} from '../constants';
import { CollectionsPageState } from '../types';
import { collectionsQueryReducer } from './collectionsQueryReducer';

const initialState: CollectionsPageState = {
  queries: {},
};

// eslint-disable-next-line import/prefer-default-export
export const collectionsPageReducer: Reducer<CollectionsPageState, CollectionsActionTypes> = (
  state = initialState,
  action: CollectionsActionTypes
): CollectionsPageState =>
  produce(state, (draft) => {
    switch (action.type) {
      case COLLECTIONS_FETCH_API_FAILURE:
      case COLLECTIONS_FETCH_API_REQUEST:
      case COLLECTIONS_FETCH_API_SUCCESS: {
        const key = makeQueryKey(action.payload.sort, action.payload.start, action.payload.search);
        draft.queries[key] = collectionsQueryReducer(state.queries[key], action);
        break;
      }

      case LOCATION_CHANGE: {
        const { location } = action.payload;
        const locationMatch = matchPath(location.pathname, {
          path: COLLECTIONS_URL,
          exact: true,
        });
        if (locationMatch) {
          return initialState;
        }
        break;
      }

      case LOGIN_API_SUCCESS:
      case LOGOUT_API_SUCCESS:
      case RESET_SESSION:
      case SELECT_SHOP_API_SUCCESS: {
        return initialState;
      }

      default:
        return draft;
    }
    return draft;
  });
